import { useEffect } from 'react'

import { Workflow } from 'workflow/shared/types'
import { TaskAction } from 'task/shared/components'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useActionHandler } from 'task/shared/hooks'
import { Taskmodel } from 'taskmodel/shared/types'

type TasksListProps = { workflow: Workflow }

const TasksList = ({ workflow }: TasksListProps) => {
  const navigate = useNavigate()

  const [searchParams] = useSearchParams()
  const shouldDisplayList = searchParams.get('displayList') === 'true'

  const taskmodels =
    workflow?.workflowmodel_instructions_from_version.taskmodels

  const pendingTask = workflow?.state.tasks.find(
    ({ status }) => status !== window.doneStatusUUID
  )
  const activeTaskmodel: Taskmodel | undefined = taskmodels.find(
    (taskModel) => taskModel?.uuid === pendingTask?.taskmodel_uuid
  )
  const isWaitingInteraction = !!activeTaskmodel?.interactionmodel_actionhandler
  const isWaitingStatus = !!activeTaskmodel?.waitforstatus_actionhandler
  const isWaitingSituation = !!activeTaskmodel?.waitforsituation_actionhandler

  const isWaitingUserInput =
    isWaitingInteraction || isWaitingStatus || isWaitingSituation

  const dataContainer = workflow?.state.data_container

  const { url: activeTaskUrl } = useActionHandler({
    taskmodel: activeTaskmodel,
    workflowUuid: workflow.uuid,
    dataContainer
  })

  useEffect(() => {
    if (isWaitingUserInput && !shouldDisplayList) {
      navigate(activeTaskUrl, { replace: true })
    }
  }, [isWaitingUserInput, shouldDisplayList, activeTaskUrl, navigate])

  if (!shouldDisplayList) return null

  return (
    <ol>
      {taskmodels?.map((taskmodel) => (
        <TaskAction
          key={taskmodel.uuid}
          taskmodel={taskmodel}
          workflowUuid={workflow.uuid}
          dataContainer={dataContainer}
          isActive={isWaitingUserInput && taskmodel === activeTaskmodel}
        />
      ))}
    </ol>
  )
}

export default TasksList
